module.exports = __webpack_public_path__ + "static/something_went_wrong-0a8111ade789c13df8422079a7cbae45.png";